import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ConversionDialog from 'components/Modals/ConversionDialog';
import { selectRemainingLoopUploads } from 'services/store/user/selectors';

interface ProLimitReachedModalProps {
  open: boolean;
  onClose?: () => void;
}

const ProLimitReachedModal = ({ open, onClose }: ProLimitReachedModalProps) => {
  const { t } = useTranslation();

  const remainingLoopUploads = useSelector(selectRemainingLoopUploads);
  const { daysToDownloadLimitReset } = remainingLoopUploads || {};

  return (
    <ConversionDialog
      title={t('aiMusicGenerator:userLoop:proUpgrade:title')}
      description={t('aiMusicGenerator:userLoop:proUpgrade:description', {
        daysToDownloadLimitReset,
      })}
      submitText={t('subscription:pricing:okayGotIt')}
      state={{
        isOpen: open,
        isLoading: false,
        error: null,
      }}
      action={{
        onClose,
        onSubmit: onClose,
      }}
    />
  );
};

export default ProLimitReachedModal;
